import React, { useState, useEffect } from 'react';
import { matchPath } from 'react-router-dom';
import { camelCase } from 'lodash';
import { useFetch } from 'components/shared/hooks';
import { routes } from 'constants/config';
import EMAILS from 'constants/emails';
import request from 'utils/request_ajax';
import { BetaFeedback } from 'components/BetaProgram';
import Skeleton from 'ui/Skeleton';
import Summary from './Summary';
import KeyTakeaways from './KeyTakeaways';

const match = () =>
  matchPath(window.location.pathname, {
    path: '/lessons/:lessonId',
  });

const LessonRecap = () => {
  const lessonId = match()?.params?.lessonId;
  const [recapData, setRecapData] = useState({
    inPublishedState: false,
    recap: '',
    keyTakeaways: '',
  });
  const { data, loading } = useFetch(routes.LESSON_OVERVIEW.RECAP(lessonId));

  const updateHandler = (field, value) => {
    const body = {
      lesson: {
        [field]: value,
      },
    };

    request.patchJSON(routes.LESSON(lessonId), body).then(
      resp =>
        resp.success &&
        setRecapData(prevState => ({
          ...prevState,
          [camelCase(field)]: value,
        })),
    );
  };

  useEffect(() => {
    if (!loading) {
      setRecapData(data);
    }
  }, [loading, data]);

  return (
    <div className="LessonRecap" style={{ marginRight: 204 }}>
      <h3 className="SectionHeading">{t('lessons.recap.title')}</h3>
      {loading ? (
        <>
          <Skeleton />
          <Skeleton height={52} className="mt-8" />

          <Skeleton className="mt-16" />
          <Skeleton height={20} className="mt-8" width="67%" />
          <Skeleton height={20} className="mt-4" width="67%" />
          <Skeleton height={20} className="mt-4" width="67%" />
        </>
      ) : (
        <>
          <Summary
            lessonId={lessonId}
            summary={recapData?.recap}
            inPublishedState={recapData?.inPublishedState}
            updateHandler={updateHandler}
          />
          <KeyTakeaways
            lessonId={lessonId}
            keyTakeaways={recapData?.keyTakeaways}
            inPublishedState={recapData?.inPublishedState}
            updateHandler={updateHandler}
          />
          <BetaFeedback
            className="mb-16"
            betaFeatureName="Lesson Recap"
            recipient={EMAILS.GPT_LESSON_FEEDBACK}
          />
        </>
      )}
    </div>
  );
};

export default LessonRecap;
